"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = exports.default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M20.419 7.358c0 .302-.152.604-.454.68-.076.076-.227.076-.302.076a.689.689 0 0 1-.53-.227l-.679-.68c-.076-.076-.227-.076-.302 0l-5.365 5.365a.958.958 0 0 1-1.36 0 .958.958 0 0 1 0-1.36l5.365-5.365a.232.232 0 0 0 0-.302l-.681-.68a.685.685 0 0 1-.226-.53c0-.453.302-.755.755-.755h3.023c.453 0 .756.302.756.756v3.022Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.49 5.692h7.437a.91.91 0 0 1 0 1.82H5.49a.09.09 0 0 0-.09.09V18.51c0 .05.04.09.09.09h10.907c.05 0 .09-.04.09-.09v-7.43a.91.91 0 1 1 1.82 0v7.43a1.91 1.91 0 0 1-1.91 1.91H5.49a1.91 1.91 0 0 1-1.91-1.91V7.602a1.91 1.91 0 0 1 1.91-1.91Z"
})), "0 0 24 24", "NewWindow");